import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'Việc theo dõi vị trí trong nhà tại các tòa nhà văn phòng có thể gây ra nhiều khó khăn. Khi số lượng văn phòng, sảnh và tầng tăng lên, khách tham quan có thể dễ dàng bị lạc và tốn nhiều thời gian để tìm kiếm địa điểm trong tòa nhà. Trong những tình huống này, doanh nghiệp cần sử dụng các giải pháp bản đồ thông minh hơn. Công nghệ mới nhất đảm bảo việc điều hướng thuận tiện liên quan đến tòa nhà và nâng cao sự hài lòng của khách hàng cũng như khách tham quan.',
  keywords:
    'Smart office, Văn phòng thông minh, Van phong thong minh, RTLS, Cách mạng công nghiệp 4.0, Cach mang cong nghiep 4.0, Quản lý công việc, Quan ly cong viec',
  ogSite: 'Năm 2023, Cách xây dựng Smart Office',
  title: 'Năm 2023, Cách xây dựng Smart Office',
  ogUrl: 'https://orbro.io/vi/blog/office',
  ogImg: '',
  ogType: 'website',
  date: '2023-05-21',
  tag1: '#Smartoffice',
  tag2: '#Vanphongthongminh',
  tag3: '#RTLS',
  tag4: '#Cachmangcongnghiep4.0 #Quanlycongviec',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Việc theo dõi vị trí trong nhà tại các tòa nhà văn phòng có thể gây ra nhiều khó khăn. Khi số lượng văn phòng, sảnh và tầng tăng lên, khách tham quan có thể dễ dàng bị lạc và tốn nhiều thời gian để tìm kiếm địa điểm trong tòa nhà. Trong những tình huống này, doanh nghiệp cần sử dụng các giải pháp bản đồ thông minh hơn. Công nghệ mới nhất đảm bảo việc điều hướng thuận tiện liên quan đến tòa nhà và nâng cao sự hài lòng của khách hàng cũng như khách tham quan.',
      dot: '',
    },
    {
      head: 'Điều hướng trong nhà cho văn phòng',
      subHead: '',
      desc: 'Sử dụng công cụ bản đồ trong nhà có thể giải quyết hiệu quả các vấn đề về điều hướng trong văn phòng. Thông qua bản đồ kỹ thuật số, người dùng có thể nhanh chóng tìm kiếm văn phòng hoặc đặt phòng họp thành công để chuẩn bị cho các sự kiện. Nếu phòng họp đó đã có người sử dụng, hệ thống cũng sẽ xác nhận điều này theo thời gian thực, từ đó ngăn chặn các trường hợp đặt phòng trùng lặp thường xảy ra trước đây. Điều này giúp tránh lãng phí thời gian do nhầm lẫn.\nHệ thống này hoạt động dựa trên việc sử dụng nhiều thẻ (tag) hoặc beacon đặc biệt được lắp đặt trong tòa nhà. Các thẻ (tag) này phát tín hiệu không dây theo các khoảng thời gian được cài đặt trước, được đầu đọc phát hiện và truyền đến máy chủ (server). Khi vào tòa nhà với một chiếc smartphone đã cài đặt sẵn ứng dụng (application), người dùng sẽ có được bản đồ tương tác để xây dựng lộ trình và thực hiện các tác vụ khác.\n\nCó thể sử dụng các công nghệ như BLE, Wi-Fi và UWB để điều hướng bên trong văn phòng. Chúng giúp thực hiện nhiều chức năng khác nhau, từ việc xác định vị trí và tìm kiếm không gian cần thiết đến đảm bảo an toàn cho nhân viên và thu thập các phân tích chi tiết.\nTheo một thống kê, hiệu quả thời gian làm việc giảm trung bình 10-20% khi gặp khó khăn trong việc tìm đường bên trong tòa nhà so với trường hợp ngược lại. Khách tham quan và nhân viên phải tốn nhiều thời gian để tìm địa điểm, điều này gây ra sự chậm trễ hoặc bắt đầu muộn các sự kiện. Lập bản đồ vị trí trong nhà (indoor location mapping) giúp giảm thiểu những vấn đề này. Những lợi ích khi triển khai trong cơ sở hạ tầng của một trung tâm thương mại (business center) hoặc văn phòng bao gồm như sau.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Điều hướng từng bước theo thời gian thực',
      desc: 'Có thể tạo ra lộ trình ngắn nhất và thuận tiện nhất đến các Địa điểm ưa thích (POI - Points of Interest). Ngoài ra, hệ thống còn gửi thông báo dựa trên vị trí của người dùng.\nPhần mềm lập bản đồ văn phòng (Office mapping software) đơn giản hóa việc điều hướng bên trong tòa nhà hoặc trung tâm thương mại/văn phòng. Việc áp dụng bản đồ tương tác giúp tối ưu hóa thời gian làm việc và nâng cao sự thoải mái cho nhân viên khi giải quyết các công việc hàng ngày.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tìm kiếm đối tượng trên bản đồ',
      desc: 'Trong hầu hết các trường hợp, sơ đồ mặt bằng thông thường trông giống như hình ảnh tĩnh, nhưng bản đồ tương tác có thể mở rộng khả năng của người dùng thông qua tính năng thu phóng linh hoạt. Nghĩa là, bạn có thể xem toàn bộ một tầng hoặc một phòng riêng biệt. Nếu cần, bạn có thể thay đổi tỷ lệ và xem xét chi tiết một số văn phòng cụ thể, bao gồm cả cách bố trí đồ đạc. Khả năng mở rộng giúp bản đồ trở nên linh hoạt hơn và giúp dễ dàng tìm thấy các đối tượng trên bản đồ. Người dùng hoặc nhân viên chỉ cần sử dụng ứng dụng di động (mobile app) để tìm phòng, phòng họp, nhà vệ sinh hoặc phòng kỹ thuật cần thiết. Kết hợp với khả năng xây dựng lộ trình, nó biến bất kỳ văn phòng nào thành một không gian thực sự đổi mới.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tương tác và tìm kiếm đồng nghiệp',
      desc: 'Một trong những vấn đề phổ biến nhất ở nhiều văn phòng là khó khăn trong việc tìm kiếm mọi người, đặc biệt là khi họ không ở tại bàn làm việc. Tính năng chia sẻ vị trí đủ để tìm thấy nhân viên mong muốn. Nhờ vào việc lập bản đồ (mapping), người dùng không cần phải chạy khắp các văn phòng và các tầng để tìm kiếm. Hệ thống này đơn giản hóa đáng kể sự tương tác và tiết kiệm thời gian.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát khu vực hạn chế',
      desc: `Đối với nhiều doanh nghiệp, lập bản đồ trong nhà (indoor mapping) trở thành một công cụ hiệu quả để giám sát các khu vực hạn chế. Những nơi này có thể là kho lưu trữ tài liệu, phòng thí nghiệm và các không gian tương tự khác cần kiểm soát. Người quản lý có thể dễ dàng theo dõi ai ra vào các khu vực này và ngăn chặn việc truy cập trái phép bằng công nghệ bản đồ trong nhà. Hệ thống có thể thông báo cho mọi người về việc tiếp cận các khu vực hạn chế. Không còn cần thiết phải dựng biển báo nữa. Các khu vực hạn chế được đánh dấu là 'Không thể truy cập' trong ứng dụng (application) và hệ thống sẽ cảnh báo nhân viên không được vào các khu vực đó.`,
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích tỷ lệ sử dụng phòng họp',
      desc: 'Thông qua nền tảng (platform) này, có thể thu thập dữ liệu về tỷ lệ sử dụng văn phòng và phòng họp. Hệ thống thực hiện thu thập thông tin liên tục và cung cấp dữ liệu thực tế theo thời gian thực. Beacon hoặc thẻ (tag) có thể thông báo về người dùng có mặt tại nơi làm việc hoặc cho biết liệu phòng đã được đặt trước hay chưa.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý an toàn',
      desc: 'Cung cấp thông tin về các tình huống khẩn cấp để đảm bảo việc sơ tán kịp thời cho mọi người. Một số phòng có khả năng cách âm tốt, khiến nhân viên có thể không nghe thấy chuông báo động. Tuy nhiên, trong trường hợp xảy ra sự cố như hỏa hoạn, họ sẽ nhận được thông tin qua ứng dụng di động (mobile application). Sau đó, hệ thống sẽ tìm nhân viên ở gần vị trí đó và hướng dẫn họ đến hiện trường để hỗ trợ hoặc giải quyết vấn đề.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giãn cách xã hội',
      desc: 'Trong thời kỳ đại dịch COVID-19, nhân viên và khách tham quan có thể tránh lây nhiễm do hệ thống có thể giám sát cẩn thận khoảng cách giữa mọi người.\nCũng có thể theo dõi việc thiết bị văn phòng bị đưa ra ngoài tòa nhà. Nếu thiết bị rời khỏi tòa nhà, hệ thống sẽ thông báo ngay lập tức.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
